// extracted by mini-css-extract-plugin
export var contentBody = "_4b-9";
export var headerImage = "_4b-2";
export var imageButton = "_4b-7";
export var imageButtonIcon = "_4b-8";
export var imageHeader = "_4b-4";
export var imageHeaderText = "_4b-5";
export var imageOverlay = "_4b-3";
export var imageTitle = "_4b-6";
export var imageWrapper = "_4b-1";
export var taskList = "_4b-a";
export var widget = "_4b-0";